import { getSocketClient } from "../serverClient";
import { getUniqueId } from "./identifiers";

const messageTypes = {
  ACKNOWLEDGE: "ack",
};

const messageStatuses = {
  OK: "ok",
};

const waitForResponse = (client, messageId, messageType) =>
  new Promise((resolve, reject) => {
    let responseHandler = null;

    const timeout = setTimeout(() => {
      client.removeEventListener("message", responseHandler);
      if (client.readyState > 1) {
        console.warn("Socket was disconnected while sending message");
        resolve("socketclosed");
        return;
      }
      reject(new Error(`Message ack not received ${messageType}`));
    }, 7000);

    responseHandler = event => {
      let res = null;
      try {
        res = JSON.parse(event.data);
      } catch (err) {
        console.error("Failed to parse json message", err, event.data);

        // If it looks like it was supposed to be our message, fail the
        // promise. If not continue and wait for the correct message.
        if (event.data.includes(messageId)) {
          reject(new Error("Failed to parse message"));
        }
        return;
      }

      // ignore messages that aren't acknowledge
      if (
        res.type !== messageTypes.ACKNOWLEDGE ||
        res.messageId !== messageId
      ) {
        return;
      }

      // We have found the ack message. Remove listeners and timeouts
      client.removeEventListener("message", responseHandler);
      clearTimeout(timeout);

      if (res.status === messageStatuses.OK) {
        resolve(res.detail || res.status);
      } else {
        reject(res.detail || res.status);
      }
    };

    client.addEventListener("message", responseHandler);
  });

export const sendServerMessage = async message => {
  try {
    const client = await getSocketClient();
    const messageId = getUniqueId();
    client.send(JSON.stringify({ ...message, messageId }));

    return waitForResponse(client, messageId, message.type);
  } catch (e) {
    console.log("Error getting socket connection to server", e);
    return Promise.reject(
      new Error("Error getting socket connection to server")
    );
  }
};



// WEBPACK FOOTER //
// ./src/lib/serverMessaging.js